var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UnderlyingCondition } from "@madmedical/medical";
import { usePatient, usePatientId } from "@madmedical/user";
import { invariant, rangeToString } from "@madmedical/utils";
import { EvaluationProvider, MeasurementCommentProvider, PregnancyMoodProvider, Spinner, } from "@madmedical/ui";
import { useCallback, useState } from "react";
import { useAuth } from "@madmedical/store";
import { useParams } from "@madmedical/routing";
import { useGetOpinionsQuery } from "../opinion/api";
import adaptOpinion from "../opinion/adaptOpinion";
import { useGetCommentsQuery } from "../comment/api";
import DeleteCommentDialog from "../comment/components/DeleteCommentDialog";
import { useGetPregnancyWellBeingsQuery } from "../pregnancy/api";
import Chart from "./Chart";
const ChartDecorated = (props) => {
    var _a, _b;
    const dateRangeString = rangeToString(props.dateRange);
    const { patientId } = usePatientId();
    const { patient } = usePatient();
    const { opinionId } = useParams();
    const { userId } = useAuth();
    const { data: opinionsData, isLoading: isOpinionsLoading } = useGetOpinionsQuery({
        patientId,
        metricTypes: [props.metricType],
        dateRange: dateRangeString,
        page: 1,
        pageSize: 7,
    });
    const { data: commentsData, isLoading: isCommentsLoading } = useGetCommentsQuery({
        patientId,
        dateRange: dateRangeString,
    });
    const [deleteCommentId, setDeleteCommentId] = useState();
    const handleDialogClose = useCallback(() => {
        setDeleteCommentId(undefined);
    }, []);
    const typedPatient = patient;
    const isPregnant = (_a = typedPatient === null || typedPatient === void 0 ? void 0 : typedPatient.underlyingConditions) === null || _a === void 0 ? void 0 : _a.includes(UnderlyingCondition.Pregnancy);
    const { data: wellBeingData, isLoading: isWellbeingLoading } = useGetPregnancyWellBeingsQuery({
        patientId,
    }, {
        skip: !isPregnant,
    });
    if (isOpinionsLoading || isCommentsLoading || isWellbeingLoading) {
        return _jsx(Spinner, {});
    }
    invariant(opinionsData);
    invariant(commentsData);
    return (_jsxs(_Fragment, { children: [_jsx(EvaluationProvider, Object.assign({ value: {
                    evaluations: opinionsData.items.map(adaptOpinion),
                    selectedId: opinionId,
                    pagination: opinionsData.pagination,
                    onSortChange: undefined,
                    onSearchChange: undefined,
                    filterChoices: undefined,
                    onFilterChange: undefined,
                } }, { children: _jsx(MeasurementCommentProvider, Object.assign({ value: {
                        comments: commentsData.map((_a) => {
                            var { date, author } = _a, rest = __rest(_a, ["date", "author"]);
                            return (Object.assign({ date: new Date(date), author: Object.assign(Object.assign({}, author), { isSelf: userId === author.id }) }, rest));
                        }),
                        onDelete: setDeleteCommentId,
                    } }, { children: _jsx(PregnancyMoodProvider, Object.assign({ value: {
                            pregnancyWellBeing: (_b = wellBeingData === null || wellBeingData === void 0 ? void 0 : wellBeingData.items) !== null && _b !== void 0 ? _b : [],
                        } }, { children: _jsx(Chart, Object.assign({}, props)) })) })) })), _jsx(DeleteCommentDialog, { id: deleteCommentId, open: !!deleteCommentId, onClose: handleDialogClose })] }));
};
export default ChartDecorated;
